import {
  SourceEntityRecordStatus,
  type FailedDestinationEntityRecord,
  type IDestinationEntity,
  type IDestinationEntityRecord,
  type IPracticeMigration,
} from '@principle-theorem/practice-migrations/interfaces';
import { User } from '@principle-theorem/principle-core';
import { ServiceTypeModality } from '@principle-theorem/principle-core/interfaces';
import { getError, type WithRef } from '@principle-theorem/shared';
import { DestinationEntity } from '../../../destination/destination-entity';
import {
  BaseStafferDestinationEntity,
  IStafferJobData,
  IStafferMigrationData,
} from '../../../destination/entities/staff';
import { type TranslationMapHandler } from '../../../translation-map';
import {
  OasisProvider,
  ProviderSourceEntity,
} from '../../source/entities/providers';
import { OasisStafferMappingHandler } from '../mappings/staff';
import { OasisStaffToUserMappingHandler } from '../mappings/staff-to-user';

export const STAFF_DESTINATION_ENTITY = DestinationEntity.init({
  metadata: {
    key: 'staff',
    label: 'Staff',
    description: ``,
  },
});

export class StafferDestinationEntity extends BaseStafferDestinationEntity<OasisProvider> {
  destinationEntity = STAFF_DESTINATION_ENTITY;
  stafferSourceEntity = new ProviderSourceEntity();
  stafferCustomMapping = new OasisStafferMappingHandler();
  staffToUserCustomMapping = new OasisStaffToUserMappingHandler();

  override sourceEntities = {
    staff: new ProviderSourceEntity(),
  };

  buildMigrationData(
    migration: WithRef<IPracticeMigration>,
    _destinationEntity: WithRef<IDestinationEntity>,
    _translationMap: TranslationMapHandler,
    data: IStafferJobData<OasisProvider>
  ):
    | IStafferMigrationData
    | (IDestinationEntityRecord & FailedDestinationEntityRecord) {
    try {
      if (
        data.stafferRecord.record.status === SourceEntityRecordStatus.Invalid
      ) {
        return this._buildErrorResponse(
          data.stafferRecord.record,
          'Source staffer is invalid'
        );
      }

      const sourceStafferId = this.sourceEntities.staff
        .getSourceRecordId(data.stafferRecord.data)
        .toString();

      const user = User.init({
        name: data.stafferRecord.data.name,
        email: '',
        practices: migration.configuration.practices.map(
          (practice) => practice.ref
        ),
        brands: [migration.configuration.brand.ref],
        isEnabled: false,
      });

      return {
        sourceStafferId,
        user,
        stafferDetails: {
          providerNumber: data.stafferRecord.data.providerNumber ?? '',
          providerModality: ServiceTypeModality.GeneralDentist,
        },
      };
    } catch (error) {
      return this._buildErrorResponse(
        data.stafferRecord.record,
        getError(error)
      );
    }
  }
}
